'use client'

import { useRouter } from 'lib/i18n/routing'
import { FlightIcon } from '@hashicorp/react-mds/src/components/flight-icon'
import type { ContactSalesPageQuery } from 'types/dato'
import s from './style.module.css'

const CloseButton = ({
	closeButtonLabel = 'Close this page',
}: Pick<ContactSalesPageQuery['contactSalesPage'], 'closeButtonLabel'>) => {
	const router = useRouter()

	return (
		<button
			className={s.closeIcon}
			onClick={() => router.back()}
			aria-label={closeButtonLabel}
		>
			<FlightIcon
				name="x"
				size={24}
				color="var(--token-color-foreground-faint)"
			/>
		</button>
	)
}

export default CloseButton
